import { Lead, LeadStatus } from 'models/Leads';
import { InboxProperty } from '../Inbox.types';
import { ThreadFilterFormLeadStatusesMap } from './InboxFilter.constants';

const formValuesToThreadFilterFieldMappers = {
  lead: (leads: Lead[]) => ({
    leadUid: leads?.length ? leads[0].uid : '',
  }),
  leadStatus: (leadStatus: LeadStatus | string) => ({
    // @ts-expect-error TS7053 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    leadStatuses: ThreadFilterFormLeadStatusesMap[leadStatus] || [],
  }),
  showUnreadOnly: (showUnreadOnly: string) => ({
    showOnlyUnread: !!showUnreadOnly, // showOnlyUnread is the param name expected by the backend
  }),
};

export const inboxGraphQLQuery = `
    uid,
    name,
    businessType,
    mainPicture{tinyThumbnail},
    subUnits{
      uid,
      name,
      businessType,
      mainPicture{tinyThumbnail},
      tags
    },
    unitTypes{
      uid,
      name,
      businessType,
      mainPicture{tinyThumbnail},
      tags
    },
    pricing{currency},
    tags
  `;

export const inboxCalendarConditionGraphQLQuery = `offset:"0",limit:"9999",isActive:true, topLevelOnly:true,returnTopLevelUnitsWithMatchingSubLevels:true,sortStrategy:"SORT_BY_NAME"`;

// @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
export const getUpdatedThreadFilter = (formValues) => {
  return Object.entries(formValues).reduce((values, entry) => {
    const key = entry[0];
    const value = entry[1];
    // @ts-expect-error TS7053 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    const fieldMapper = formValuesToThreadFilterFieldMappers[key];
    return {
      ...values,
      ...(fieldMapper ? fieldMapper(value) : { [key]: value }),
    };
  }, {});
};

export const getPropertiesFilteredByTags = (
  properties: InboxProperty[],
  propertyTags: { label: string; value: string }[],
) => {
  if (!propertyTags || propertyTags.length === 0) {
    return properties;
  }

  const selectedTagValues = new Set(
    propertyTags.map((propertyTag: { label: string; value: string }) =>
      propertyTag.value.toLowerCase(),
    ),
  );

  const hasAnySelectedTag = (tags?: string[]) =>
    !!tags?.some((tag) => selectedTagValues.has(tag.toLowerCase()));

  const filteredProperties = properties
    .map((property) => {
      const matchingSubUnits =
        property.subUnits?.filter((su) => hasAnySelectedTag(su.tags)) ?? [];

      const matchingUnitTypes =
        property.unitTypes?.filter((ut) => hasAnySelectedTag(ut.tags)) ?? [];

      const propertyMatches = hasAnySelectedTag(property.tags);

      const shouldKeepParent =
        propertyMatches ||
        matchingSubUnits.length > 0 ||
        matchingUnitTypes.length > 0;

      if (!shouldKeepParent) return null;

      return {
        ...property,
        subUnits: matchingSubUnits,
        unitTypes: matchingUnitTypes,
      } as InboxProperty;
    })
    .filter((p) => p !== null) as InboxProperty[];

  return filteredProperties;
};
